import React, { useState, useEffect } from "react";
import { Modal, Button } from "@deere/ux.uxframe-react";
import { useTranslation } from "react-i18next";
import { TextField, SelectField, Option, Typography, Grid, FormControl, Link } from "@deere/fuel-react";
import { QUESTION_TYPES, POPUP_QUESTIONS_TITLES } from "../../utils/constants";
import { getTranslation, getSelectionsDependson } from "../../utils/utils";
import { ERR_PROVIDE_ALL_VALUES, ERR_NUMERIC_VALUES_FOR,ERR_UNSUPPORTED_FILE, ERR_DUPLICATE_FILE,ERR_UNEXPECTED_ERROR_FILE  } from "../../utils/errorLiterals";
import { getBoundary } from "../../services/external.service";
import { useDispatch, useSelector } from 'react-redux';
import { updateStateByQuesIdList } from "../../redux/action/surveyPartAction";
import { DEFAULT_GRID_COLLUMNS } from "../../utils/surveyLiterals";

const ModalCellPopup = ({ showModal, setShowModal, popupCellParams, saveHandler, questions, checkIfError, token, isAuthMethodOkta, fileUploadHandler, fileDownloadHandler }) => {
  const [answers, setAnswers] = useState([]);
  const [questionsToBeRendered, setQuestionsToBeRendered] = useState([]);
  const [error, setError] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const countryList = useSelector(state => state.surveyPartReducer.countryList);
  const countryListWithUnknown = [
    ...(countryList || []),
    { iso2CountryCode: "UN", name: "Unknown" },
  ];
  const stateList = useSelector(state => state.surveyPartReducer.stateList);
  const [uploaderror, setUploadError] = useState({ isError: false, message: "" });
  const [attachments, setAttachments] = useState([]);

  /***********************************Set up for questions to be displayed in popup**********************************/
  useEffect(() => {
    let childQuesIds = [];
    let arrTempAnswers = [];
    let arrTempQues = [];
    popupCellParams.currentQue.children.forEach((ch) => {
      childQuesIds = childQuesIds.concat(ch.children);
    });
    questions.forEach((que) => {
      if (childQuesIds.includes(que.id)) {
        arrTempQues.push(que);
        let existingValue = popupCellParams.rowParams.row["que_" + que.id];
        arrTempAnswers.push({ fieldName: "que_" + que.id, value: existingValue });
      }
    });
    setQuestionsToBeRendered([...arrTempQues]);
    setAnswers([...arrTempAnswers]);
  }, []);

  /*********************************Render the question based on parent ans selection********************************/
  const shouldRender = (que) => {
    let render = false;
    let parent = questions.find((q) => q.id === que.idQuestionDepends);
    if (parent) {
      let parentAns = answers.find((ans) => ans.fieldName === "que_" + parent.id);
      if (POPUP_QUESTIONS_TITLES.includes(parent?.type)) {
        render = true;
      } else if (que.idSelectionDependson === 0) {
        if (parentAns && parentAns.value && parentAns.value !== "") {
          render = true;
        }
      } else if (parentAns && getSelectionsDependson(que).includes(String(parentAns.value))) {
        render = true;
      }
    }
    return render;
  };

  const validateData = () => {
    let isEmpty = false;
    let isNotNum = false;
    let queWithError = "";
    for (let i = 0; i < answers.length; i++) {
      let que = questions.find((q) => "que_" + q.id === answers[i].fieldName);
      if (que.required && answers[i].value === "") {
        if (que.idQuestionDepends && que.idQuestionDepends !== 0) {
          let parentQue = questions.find((q) => q.id === que.idQuestionDepends);
          if (parentQue && !POPUP_QUESTIONS_TITLES.includes(parentQue.type)) {
            let parentAns = answers.find((ans) => ans.fieldName.split("_")[1] === parentQue.id.toString());
            if (parentAns && parentAns.value !== "") {
              if (que.idSelectionDependson !== null && que.idSelectionDependson === 0) {
                if (que.type === QUESTION_TYPES.SEL_STATE && (parentQue.type === QUESTION_TYPES.SEL_CNTRY || parentQue.type === QUESTION_TYPES.SEL_CTY_UW)) {
                  const optStates = stateList.find((sl) => sl.country === parentAns.value);
                  if(optStates && optStates.states && optStates.states.length > 0) {
                    isEmpty = true;
                  }
                } else {
                  isEmpty = true;
                }
              } else if (que.idSelectionDependson > 0 && getSelectionsDependson(que).includes(String(parentAns.value))) {
                isEmpty = true;
              }
            }
          } else {
            isEmpty = true;
          }
        } else {
          isEmpty = true;
        }
      } else if (que && que.type === QUESTION_TYPES.NUM && answers[i].value !== "") {
        let validParameter = new RegExp(/[0-9]+([.][0-9]+)?$/);
        if (!validParameter.test(answers[i].value)) {
          isNotNum = true;
          queWithError = getTranslation(que, "text");
          break;
        }
      }
    }
    if (isEmpty) setError(ERR_PROVIDE_ALL_VALUES);
    else if (isNotNum) setError(`${ERR_NUMERIC_VALUES_FOR}'${queWithError}'`);
    else resetUnrenderedQuestionValues();
  };

  const resetUnrenderedQuestionValues = () => {
    let data = [...answers];
    data.forEach((d) => {
      let isRendered = document.getElementById(d.fieldName);
      if (!isRendered) d.value = "";
    });
    setValueForColumnHeaders(data);
  };

  const setValueForColumnHeaders = (data) => {
    let directChildOfColumnHeader = questions.find((que) => que.idQuestionDepends === popupCellParams.currentQue.id);
    let directChildAnswer = directChildOfColumnHeader ? data.find((ans) => ans.fieldName === "que_" + directChildOfColumnHeader.id) : null;
    let valueForColumnHeader = [{ fieldName: "que_" + popupCellParams.currentQue.id, value: directChildAnswer ? directChildAnswer.value : "" }];
    if (popupCellParams.currentQue.type === QUESTION_TYPES.TITL_POPUP) {
      if (directChildOfColumnHeader.selections.length > 0) {
        if (directChildAnswer) {
          const selectionIdx = directChildOfColumnHeader.selections.findIndex((sel) => sel.value.toString() === directChildAnswer.value);
          const selection = selectionIdx > -1 ? directChildOfColumnHeader.selections[selectionIdx] : null;  
          valueForColumnHeader[0].value = selection ? selection.text : "";
        } else {
          valueForColumnHeader[0].value = directChildAnswer ? directChildAnswer.value : "";
        }
      }
    } else if (popupCellParams.currentQue.type === QUESTION_TYPES.CHEK_POPUP) {
      valueForColumnHeader[0].value = directChildAnswer.value && directChildAnswer.value !== "" ? "1" : "";
    }
    saveHandler(popupCellParams.rowParams.id, [...valueForColumnHeader, ...data]);
    closeModal();
  };

  const closeModal = () => {
    setError("");
    setAnswers([]);
    setQuestionsToBeRendered([]);
    setShowModal(false);
  };

  /***************************************Value changeHandler******************************************/

  const changeHandler = (event, queId, filePath) => {
    setError("");
    const question = questions.find((q) => q.id === queId);
    setAnswers((prevState) => {
      let index = prevState.findIndex((ans) => ans.fieldName === "que_" + queId);
      if (index > -1) {
        if (question.type === QUESTION_TYPES.FILE) {
          prevState[index].value = filePath;
        } else {
          prevState[index].value = event.target.value;
        }
        
      }
      if(question.type === QUESTION_TYPES.SEL_CNTRY || question.type === QUESTION_TYPES.SEL_CTY_UW){
        const parentQue = questions.find((q) => q.type === QUESTION_TYPES.SEL_STATE && q.idQuestionDepends === queId);
        const parentQueId = parentQue && parentQue.id ? parentQue.id : null;
        const parentIndex = parentQueId ? prevState.findIndex((ans) => ans.fieldName === "que_" + parentQueId) : -1;
        if(parentIndex > -1){
          prevState[parentIndex].value = "";
        }
      }
      return [...prevState];
    });
    if (question.type === QUESTION_TYPES.SEL_CNTRY || question.type === QUESTION_TYPES.SEL_CTY_UW) {
      const stateIndex = stateList.findIndex((sl) => sl.country === event.target.value);
      if(stateIndex === -1) getStateList(event.target.value , question.type === QUESTION_TYPES.SEL_CTY_UW ? true : false);
    }
  };

  /******************************************Render Methods******************************************/

  const createInput = (que) => {
    const showError = checkIfError(popupCellParams.rowParams.id, que.id, false);
    const answer = answers.find((ans) => ans.fieldName === "que_" + que.id);
    return <TextField error={showError} onChange={(e) => changeHandler(e, que.id)} value={answer && answer.value ? answer.value : ""} variant="outlined" label={getTranslation(que, "text")} />;
  };

  const createSelect = (que) => {
    const showError = checkIfError(popupCellParams.rowParams.id, que.id, false);
    const answer = answers.find((ans) => ans.fieldName === "que_" + que.id);
    return (
      <SelectField error={showError} label={getTranslation(que, "text")} value={answer && answer.value ? answer.value : ""} onChange={(e) => changeHandler(e, que.id)}>
        <Option value="">
          {t("lbl_dropdown_select")}
        </Option>
        {que.selections
          .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
          .map((i) =>
            i.active ? (
              <Option key={`${i.id}`} value={i.value}>
                {getTranslation(i, "text")}
              </Option>
            ) : (
              ""
            )
          )}
      </SelectField>
    );
  };

  const createCountrySelect = (que, includeUnknown = false) => {
    const showError = checkIfError(popupCellParams.rowParams.id, que.id, false);
    const answer = answers.find((ans) => ans.fieldName === "que_" + que.id);
    const countryOptions = includeUnknown ? countryListWithUnknown : countryList;
    return (
      <SelectField error={showError} label={getTranslation(que, "text")} value={answer && answer.value ? answer.value : ""} onChange={(e) => changeHandler(e, que.id)} disabled={!countryOptions || countryOptions.length === 0}>
        {countryOptions && countryOptions.length > 0 ? (
          <Option value="">
            {t("lbl_dropdown_select")}
          </Option>
        ) : (
          <Option disabled value="">
            {t("country_list_unavailable")}
          </Option>
        )}
        {countryOptions &&
          countryOptions.length > 0 &&
          countryOptions.map((opt) => (
            <Option key={opt.iso2CountryCode} value={opt.name}>
              {opt.name}
            </Option>
          ))}
      </SelectField>
    );
  };

  const createStateSelect = (que) => {
    const showError = checkIfError(popupCellParams.rowParams.id, que.id, false);
    const answer = answers.find((ans) => ans.fieldName === "que_" + que.id);
    const parentQue = questions.find((q) => q.id === que.idQuestionDepends && (q.type === QUESTION_TYPES.SEL_CNTRY || q.type === QUESTION_TYPES.SEL_CTY_UW));
    const parentAns = parentQue ? answers.find((ans) => ans.fieldName === "que_" + parentQue.id) : null;
    const optStates = parentAns && parentAns.value ? stateList.find((sl) => sl.country === parentAns.value) : [];
    return (
      <SelectField error={showError} label={getTranslation(que, "text")} value={answer && answer.value ? answer.value : ""} onChange={(e) => changeHandler(e, que.id)}>
        {optStates && optStates.states && optStates.states.length > 0 ? (
          <Option value="">
            {t("lbl_dropdown_select")}
          </Option>
        ) : (
          <Option disabled value="">
            {t("not_available")}
          </Option>
        )}
        {optStates &&
          optStates.states &&
          optStates.states.length > 0 &&
          optStates.states.map((opt) => (
            <Option key={opt.iso2CountryCode} value={opt.name}>
              {opt.name}
            </Option>
          ))}
      </SelectField>
    );
  };

  const createFileInput = (que) => {
    const answer = answers.find((ans) => ans.fieldName === "que_" + que.id);
    return (
      <Grid container spacing={6}>
        <Grid item xs={answer.value && answer.value !== "" ? 10 : 12}>
          <FormControl fullWidth id={que.code}>
            <TextField
              type="file"
              id={que.code}
              onChange={(e) => {
                fileUploadHandler(e, popupCellParams.rowParams, que, true);
                changeHandler(e, que.id, event.target.files[0].name)
              }}
              label={getTranslation(que, "text")}
              sx={{ "& .MuiInputBase-input": { height: "auto" }, "& .MuiFormLabel-root": { fontSize: "14px" } }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={2} alignContent={"flex-end"}>
          <Typography size="xs" fontWeight={"semibold"} component="label">
            {answer.value && answer.value !== "" && (
              <Link mr={1} href="#" onClick={(e) => fileDownloadHandler(e, popupCellParams.rowParams, que)}>
                {"View Added File"}
              </Link>
            )}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  /***********************************API Call to fetch State List***********************************/
  const getStateList = (selectedCountry , includeUnknown) => {
    const countryListToSearch = includeUnknown ? countryListWithUnknown : countryList;
    const countryCode = countryListToSearch.find((c) => c.name === selectedCountry);
    if (countryCode && countryCode.iso2CountryCode) {
      getBoundary(token, countryCode.iso2CountryCode)
        .then((res) => {
          if (Array.isArray(res)) {
            res.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
            dispatch(updateStateByQuesIdList({country: selectedCountry, states: res}));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getCollumnsByQuestion = (questions, questionsGroup) => {
    const questionsInGroup = questions.filter((q) => q.questionsGroup === questionsGroup);
    return questionsInGroup ? DEFAULT_GRID_COLLUMNS / questionsInGroup.length : DEFAULT_GRID_COLLUMNS;
  };

  return (
    <Modal size="lg" show={showModal} backdrop="static">
      <Modal.Header>
        <Typography variant="h2">{getTranslation(popupCellParams.currentQue, "text")}</Typography>
      </Modal.Header>
      <Modal.Body className="overflow-scroll">
        <Grid container spacing={2}>
          {questionsToBeRendered.map((que) => {
            const collumnsByQuestion = que.questionsGroup ? getCollumnsByQuestion(questionsToBeRendered, que.questionsGroup) : DEFAULT_GRID_COLLUMNS;
            return shouldRender(que) ? (
              <Grid item id={"que_" + que.id} key={que.id} style={{ marginBottom: "20px" }} xs={collumnsByQuestion}>
                {que.type === QUESTION_TYPES.NUM || que.type === QUESTION_TYPES.OPEN ? createInput(que) : <></>}
                {que.type === QUESTION_TYPES.SELECT ? createSelect(que) : <></>}
                {que.type === QUESTION_TYPES.SEL_CNTRY ? createCountrySelect(que, false) : <></>}
                {que.type === QUESTION_TYPES.SEL_CTY_UW ? createCountrySelect(que, true) : <></>}
                {que.type === QUESTION_TYPES.SEL_STATE ? createStateSelect(que) : <></>}
                {que.type === QUESTION_TYPES.FILE ? createFileInput(que) : <></>}
              </Grid>
            ) : null;
          })}
          {error !== "" && <div style={{ color: "red", fontSize: "smaller" }}>{error}</div>}
        </Grid>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          {t("btn_cancel")}
        </Button>
        <Button type="submit" variant="primary" onClick={validateData}>
          {t("btn_save_survey")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCellPopup;
